import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";

export const OuterWrapper = styled.div<{ $isSticky?: boolean }>`
    display: flex;
    width: 100%;
    /* sticky keeps the footer in normal flow so content is never hidden behind it; fixed (default)
       preserves the original overlay behaviour */
    position: ${(props) => (props.$isSticky ? "sticky" : "fixed")};
    bottom: 0;
    z-index: 10;

    ${(props) => props.$isSticky && "margin-top: auto;"}
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${DesignConstants.SPACES.S} 0;
    background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    width: 100%;

    button > div {
        white-space: normal;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        gap: ${DesignConstants.SPACES.S};
        flex-wrap: wrap;

        > button {
            width: 100%;
        }
    }
`;
